var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMockIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8008 17.2998C12.3531 17.2998 12.8008 16.8521 12.8008 16.2998C12.8008 15.7475 12.3531 15.2998 11.8008 15.2998C11.2485 15.2998 10.8008 15.7475 10.8008 16.2998C10.8008 16.8521 11.2485 17.2998 11.8008 17.2998Z",
    fill: "#FFFFFE",
    stroke: "#FFFFFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5556 10H3.44444C2.09441 10 1 10.97 1 12.1667V20.8333C1 22.03 2.09441 23 3.44444 23H20.5556C21.9056 23 23 22.03 23 20.8333V12.1667C23 10.97 21.9056 10 20.5556 10Z",
    stroke: "#FFFFFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40039 9.8V6.5C6.40039 5.04131 6.97985 3.64236 8.0113 2.61091C9.04275 1.57946 10.4417 1 11.9004 1C13.3591 1 14.758 1.57946 15.7895 2.61091C16.8209 3.64236 17.4004 5.04131 17.4004 6.5V9.8",
    stroke: "#FFFFFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMockIcon);
export default __webpack_public_path__ + "static/media/MockIcon.ea1b8b354f4bd66e176405e95d74f86e.svg";
export { ForwardRef as ReactComponent };